import { Show } from 'solid-js';
import { Switch } from '@components';
import { useSettings, useLicense } from '@util/context';

export default function Cache() {
	const { settings } = useSettings();
	const { isLocked, shakePromo } = useLicense();

	return (
		<div class="ap-space-y-8">
			{/* Prefetch Settings */}
			<div class="ap-space-y-6">
				<h3 class="ap-text-lg ap-font-semibold ap-text-slate-900">Prefetch</h3>

				<Switch
					data-tour="prefetch-toggle"
					value={settings.enable_prefetch}
					onChange={(v) => isLocked() ? shakePromo() : settings.enable_prefetch = v}
					subtitle="Prefetch pages when users hover over links for instant loading."
					locked={isLocked()}
					tooltip={
						<>
							<strong>Prefetches page content</strong> when users hover over links.<br /><br />
							When enabled, AjaxPress will fetch page content in the background as users hover over links. When they click, the page loads instantly.<br /><br />
							<em>Significantly improves perceived performance with minimal bandwidth cost.</em>
						</>
					}
				>
					Enable Prefetch
				</Switch>
			</div>

			{/* Static Cache - Coming Soon */}
			<div class="ap-pt-4 ap-border-t ap-border-slate-200">
				<div class="ap-p-5 ap-bg-gradient-to-br ap-from-slate-50 ap-to-slate-100 ap-rounded-lg ap-border ap-border-slate-200">
					<div class="ap-flex ap-items-start ap-gap-4">
						<div class="ap-flex-shrink-0 ap-w-10 ap-h-10 ap-bg-indigo-100 ap-rounded-lg ap-flex ap-items-center ap-justify-center">
							<svg class="ap-w-5 ap-h-5 ap-text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
							</svg>
						</div>
						<div class="ap-flex-1">
							<div class="ap-flex ap-items-center ap-gap-2 ap-mb-1">
								<h4 class="ap-font-semibold ap-text-slate-900">Super Fast Caching</h4>
								<span class="ap-text-[10px] ap-font-bold ap-px-2 ap-py-0.5 ap-rounded ap-uppercase ap-bg-indigo-100 ap-text-indigo-600">Coming Soon</span>
							</div>
							<p class="ap-text-sm ap-text-slate-600">
								Server-side page caching for lightning-fast load times. Serve cached pages instantly without PHP processing.
							</p>
							<Show when={isLocked()}>
								<p class="ap-text-sm ap-text-amber-700 ap-mt-2 ap-font-medium">
									Upgrade now to get early access when released — price increases at launch.
								</p>
							</Show>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
